/**
 * Viewer 模式枚举。
 *
 * 设计说明：
 * 1. 该枚举从 Viewer 运行时主类中独立拆出，避免模式常量反向拉入整个 Viewer 模块；
 * 2. interactionState / selection / reference 等模块只依赖模式语义时，应优先从本文件导入；
 * 3. 这样可以收口运行时依赖边界，避免基准状态类与 Viewer 初始化链形成循环依赖。
 */

export enum ViewerMode {
    /** 默认状态。 */
    Default = 'default',
    /** 装配体状态。 */
    Assembly = 'assembly',
    /** 移动零部件状态。 */
    MoveComponent = 'move-component',
    /** 线性零部件阵列状态。 */
    LinearComponentPattern = 'linear-component-pattern',
    /** 基准面状态。 */
    ReferencePlane = 'reference-plane',
    /** 基准轴状态。 */
    ReferenceAxis = 'reference-axis',
    /** 基准点状态。 */
    ReferencePoint = 'reference-point',
    /** 装配体模式下基准面状态。 */
    AssemblyReferencePlane = 'assembly-reference-plane',
    /** 装配体模式下基准轴状态。 */
    AssemblyReferenceAxis = 'assembly-reference-axis',
    /** 装配体模式下基准点状态。 */
    AssemblyReferencePoint = 'assembly-reference-point',
    /** 草图状态。 */
    Sketch = 'sketch',
    /** 草图绘制状态。 */
    SketchDrawing = 'sketch-drawing',
    /** 草图移动实体状态。 */
    SketchMoveEntities = 'sketch-move-entities',
    /** 草图复制实体状态。 */
    SketchCopyEntities = 'sketch-copy-entities',
    /** 草图旋转实体状态。 */
    SketchRotateEntities = 'sketch-rotate-entities',
    /** 圆周草图阵列状态。 */
    SketchCircularPattern = 'sketch-circular-pattern',
    /** 草图镜向实体状态。 */
    SketchMirrorEntities = 'sketch-mirror-entities',
    /** 草图修剪状态。 */
    SketchTrim = 'sketch-trim',
    /** 草图智能尺寸状态。 */
    SketchDimension = 'sketch-dimension',
    /** 草图等距实体状态。 */
    SketchOffset = 'sketch-offset',

    /** 测量（评估）状态。 */
    Measure = 'measure',
}
